import { post } from 'utils/rest-clients';
import { setSessionConfig } from 'utils/authSessionForCode/sessionConfig';

export async function initSessionConfigForCode(code: string) {
  const response = await post<{ access_token: string }>(
    `integration/client/oauth/token`,
    `grant_type=authorization_code&code=${code}`,
    {
      headers: {
        accept: 'application/json',
        'content-type': 'application/x-www-form-urlencoded'
      },
      fetchOptions: {
        refreshToken: false
      }
    }
  );
  const jwt: string | undefined = response.data.access_token;
  const xsrfToken: string | undefined = response.headers['X-XSRF-TOKEN']; // this does not exist

  setSessionConfig(jwt, xsrfToken);
}
